import YASQE from "@triply/yasqe";

const propertiesCompleter = {

    isValidCompletionPosition: function (yasqe) {
        return YASQE.Autocompleters.property.isValidCompletionPosition(yasqe);
    },
    preProcessToken: function (yasqe, token) {
        return YASQE.Autocompleters.property.preProcessToken(yasqe, token);
    },
    postProcessSuggestion: function (yasqe, token, suggestedString) {
        return YASQE.Autocompleters.property.postProcessSuggestion(yasqe, token, suggestedString);
    },
    name: "propertiesCompleter",
    bulk: true,
    async: false,
    autoShow: true,
    persistent: false,
    get: function (yasqe) {
        return yasqe.options.propertyList;
    }

};

export default propertiesCompleter;
